import { Stack } from '@etg/wings';
import type { TripSegmentType } from '../../../models';
import { getFlightsForVerification } from './utils';
import BookingVerification from './BookingVerification';
import DrawerReadMore from './DrawerReadMore';
import GeneralInfo from './GeneralInfo';

interface DrawerContentProps {
  carrierName: string;
  lccTripSegments: TripSegmentType[];
}
const DrawerContent = ({ carrierName, lccTripSegments }: DrawerContentProps) => {
  const verificationBookingsInfo = getFlightsForVerification(lccTripSegments);
  const verificationBookingNumbers = Object.keys(verificationBookingsInfo);

  return (
    <Stack id="carrier-verification-drawer-content">
      <GeneralInfo
        carrierBookingNumbersCount={verificationBookingNumbers.length}
        carrierName={carrierName}
      />
      {verificationBookingNumbers.map((bookingNumber) => (
        <BookingVerification
          bookingNumber={bookingNumber}
          bookingNumberDetails={verificationBookingsInfo[bookingNumber]}
          key={`${bookingNumber}verification-card`}
        />
      ))}
      <DrawerReadMore carrierName={carrierName} />
    </Stack>
  );
};

export default DrawerContent;
